import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/react-hooks';

import categoriesQuery from './CategoriesContext.graphql';

const CategoriesContext = React.createContext([]);

export const CategoriesProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [categories, setCategories] = useState([]);

  const { data, isError, isLoading: isQueryLoading } = useQuery(categoriesQuery);

  useEffect(() => {
    if (!isQueryLoading && data) {
      setCategories(data.fetchAppCategories.data);
    }
    setIsLoading(isQueryLoading);
  }, [data, isQueryLoading]);

  const value = {
    isLoading,
    isError,
    categories,
  };

  return <CategoriesContext.Provider value={value}>{children}</CategoriesContext.Provider>;
};

CategoriesProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
export default CategoriesContext;
